import type { MessageDescriptor } from '@lingui/core';
import { useCallback } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { describeApiError, GetErrorReasonOptions, isDuplicateRequest } from 'shared/errors';

export interface ToastApiErrorOptions extends GetErrorReasonOptions {
  toastOptions?: ToastOptions;
}

/**
 * Показ ошибки запроса: заголовок места вызова + причина из реестра кодов (`shared/errors`).
 *
 * @example
 * const toastApiError = useToastApiError();
 * try {
 *   await deletePlayer(id).unwrap();
 * } catch (error) {
 *   toastApiError(error, msg`Не удалось удалить игрока`);
 * }
 */
export function useToastApiError() {
  return useCallback((error: unknown, title: MessageDescriptor, options: ToastApiErrorOptions = {}) => {
    // Повтор запроса (код 15) — не отказ: первый запрос уже всё сделал и покажет успех сам.
    if (isDuplicateRequest(error)) return;
    const { toastOptions, ...reasonOptions } = options;
    const text = describeApiError(error, title, reasonOptions);
    // Без лишнего `undefined` вторым аргументом: тесты проверяют тост одним `toHaveBeenCalledWith(text)`.
    if (toastOptions) toast.error(text, toastOptions);
    else toast.error(text);
  }, []);
}
